import React from 'react';
import { Row, Col, Descriptions, Tabs, Select, message , Table, Space, Button, Spin, Upload  } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import "moment/locale/zh-cn";
import { APIService } from '../../../services/commission/api';
import { returnIframeUrl } from "../../../lib/http";
import './Annex.scss';

const listData = {
    "招商平台": ['临时公告信息','发行方管理报告信息','成立公告信息','清算公告信息','到期公告信息'],
    "平安平台": ['成立公告','到期公告','清算公告','资金管理报告月度','资金管理报告季度','资金管理报告半年度','资金管理报告年度','资金管理报告清算报告'],
}

export default class Annex extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            PrevData: [],
        }
    }

    componentDidMount() {
        this.props.data.present.f6 == '信披报告' ? this.LetterData() : this.getDate()
    }

    getOpenYearFromPresent = () => {
        try {
            const { present } = this.props.data;
            if (!present || !present.f7) {
                return null;
            }
            var f7Obj = JSON.parse(present.f7);
            if (
                !f7Obj ||
                !f7Obj.INFBDY ||
                !f7Obj.INFBDY.PMSWMONAX2 ||
                !f7Obj.INFBDY.PMSWMONAX2.length
            ) {
                return null;
            }
            var firstFile = f7Obj.INFBDY.PMSWMONAX2[0];
            var fileName = firstFile && firstFile.fileName;
            if (!fileName) {
                return null;
            }
            var nameWithoutExt = fileName.split('.')[0];
            var year = nameWithoutExt.split('_').pop();
            if (/^\d{4}$/.test(year)) {
                return year;
            }
            return null;
        } catch (e) {
            return null;
        }
    };

    // 获取 信披报告 数据
    LetterData = () => {
        const { present } = this.props.data;
        let params = {
            row_id: present._id,
        }
        this.setState({ loading: true })
        APIService.getUrlData('/citic/get_xp_report_info/',params).then(res => {
            if(!res.success) return this.setState({ loading: false },() => message.error(res.error)) 
            let datas = JSON.parse(JSON.stringify(res.data))
            let arr = listData[present.f17];
            let PrevData = [];
            arr.forEach(e => {
                if(datas[e] && datas[e].data.length){
                    datas[e].data.forEach(item => {
                        item['uid'] = item.file_id;
                        item['name'] = item.report_name;
                        item['status'] = 'done';
                        item['url'] = item.file_url;
                    })
                    PrevData.push(datas[e])
                }
            })
            this.setState({ 
                PrevData,
                loading: false 
            })
        }).catch(error => {
            this.setState({ loading: false })
            message.error(error)
        })
    }

    // 获取日期
    getDate = () => {
        const { present } = this.props.data;
        let params = {
            p_code: present.f19,
            record_id: present._id,
            data_type: -1,
        }
        APIService.getUrlData('/citic/get_dxjg_proj_info/',params).then(res => {
            if(!res.success) return this.setState({ loading: false },() => message.error(res.error)) 
            this.Period(res.data[0])
        })
    }

    // 获取 开放期计划 数据
    Period = (date) => {
        const { present } = this.props.data;
        const fileYear = this.getOpenYearFromPresent();
        const open_year = fileYear || date;
        let params = {
            p_code: present.f19,
            data_type: '3',
            record_id: present._id,
            open_year,
        }
        this.setState({ loading: true })
        APIService.getUrlData('/citic/get_dxjg_proj_info/',params).then(res => {
            if(!res.success) return this.setState({ loading: false },() => message.error(res.error)) 
            let data = res.data['开放期计划信息'];
            let PrevData = [];
            PrevData.push({
                name: '开放期计划',
                data: [
                    {
                        uid: res.file_id,
                        name: data['文件名'].data,
                        status :'done',
                        url: returnIframeUrl(`/download_attachment/?file_id=${res.file_id}&download=0&dinput_type=9&record_type=table`),
                    }
                ],
            })
            this.setState({ PrevData, loading: false, })
        }).catch(error => {
            this.setState({ loading: false })
            message.error(error)
        })
    }

    download = (file) => {
        console.log(file,'file');
        let obj = {
            file_id: file.file_id,
            download: 1
        }
        let url = returnIframeUrl('/download_attachment/', obj);
        let aElement = document.createElement('a'); //创建节点
        document.body.appendChild(aElement);
        aElement.style.display = 'none';
        aElement.href = url;
        aElement.target = '_blank';
        aElement.click();
        document.body.removeChild(aElement);
    }

    render() {
        const { loading, PrevData } = this.state;
        const { present } = this.props.data;
        return (
            <div id='Annex'>
                <Spin spinning={loading}>
                    <Descriptions
                        bordered
                        column={1}
                        className='fileList'
                        labelStyle={{ 
                            width: "200px",
                            whiteSpace: "nowrap" // 禁止标签文字换行 
                        }}
                    >
                        {
                            PrevData.map(e => {
                                return <Descriptions.Item label={e.name} key={e.name}>
                                    {
                                        present.f6 == '开放期计划' ?
                                        <div style={{ cursor:'pointer',color:'#0000ff', minWidth: '500px' }} onClick={()=>this.download({ file_id: e.data[0].uid })}>{ e.data.length > 0 && e.data[0].name}</div>:
                                        <Upload 
                                            action='' 
                                            defaultFileList={e.data} 
                                            showUploadList={{
                                                showDownloadIcon: true,
                                                downloadIcon: <ArrowDownOutlined/>,
                                                showRemoveIcon: false,
                                            }}
                                            onDownload={this.download}
                                            className="custom-upload"
                                        />
                                    }
                            </Descriptions.Item>
                            })
                        }
                    </Descriptions>
                </Spin>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// app/components/customPage/Annex/Annex.jsx